export { default } from '@/fragments/user-access/activate';
